<template>
  <div
    class="header navbar app-navbar"
    :style="`
			position: fixed !important;
			width: calc(100% - ${size_left}px);
			margin-left: ${size_left}px;
			margin-right: 0;
			padding: 0;`"
  >
    <div class="header-container">
      <ul class="nav-left">
        <li>
          <a @click.prevent="foldSidebar" class="sidenav-fold-toggler" href="#">
            <i class="mdi mdi-menu" />
          </a>
          <a
            @click.prevent="expandSidebar"
            class="sidenav-expand-toggler"
            href="#"
          >
            <i class="mdi mdi-menu" />
          </a>
        </li>
      </ul>
      <ul class="nav-right d-flex align-items-center">
        <li class="list-item d-xl-block d-none">
          <a href="#" v-if="$store.state.user.unidade">
            <span class="line" :title="$store.state.user.unidade.nome">{{
              $store.state.user.unidade.nome
            }}</span>
            -
            {{ $store.state.settings.app_cidade }}
          </a>
        </li>
        <li>
          <span @click="showPesquisa" title="Pesquisa" class="px-1">
            <i class="mdi mdi-magnify mdi-24px"></i>
          </span>
        </li>
        <li>
          <notify />
        </li>
        <li>
          <router-link
            v-if="messages > 0"
            to="/dashboard/chat"
            title="Chat"
            class="px-1"
          >
            <div class="nots mx-1" style="position: relative">
              <div class="animate__animated animate__tada animate__infinite">
                <i class="mdi mdi-message-reply-text mdi-24px text-white"></i>
              </div>
              <span class="badge badge-light badge-danger text-white">
                {{ messages }}
              </span>
            </div>
          </router-link>
          <router-link v-else to="/dashboard/chat" title="Chat" class="px-1">
            <i class="mdi mdi-message-reply-text"></i>
          </router-link>
        </li>
        <!-- <li>
					<router-link
						v-if="$store.state.user.permissions.DemandaController"
						to="/dashboard/demandas"
						title="Demanda"
						class="px-1"
					>
						<i class="mdi mdi-file-move"></i>
					</router-link>
				</li> -->
        <li>
          <router-link to="/dashboard/suportes" title="Suporte" class="px-1">
            <i class="mdi mdi-face-agent"></i>
          </router-link>
        </li>
        <li>
          <router-link
            to="/dashboard/admin/central/home"
            title="Central de Atendimento SUAS Fácil"
            class="px-1"
          >
            <i class="mdi mdi-lifebuoy"></i>
          </router-link>
        </li>
        <li class="user-profile dropdown dropdown-animated scale-left">
          <a class="dropdown-toggle" data-toggle="dropdown" href="#">
            <img
              :alt="$t('User avatar')"
              :src="$store.state.user.avatar"
              class="profile-img img-fluid m-1"
              id="profile-img-avatar"
              :title="$store.state.user.name"
              v-if="$store.state.user.avatar"
            />
          </a>
          <ul class="dropdown-menu dropdown-md p-v-0">
            <li>
              <ul class="list-media">
                <li class="list-item p-15">
                  <div class="media-img">
                    <img
                      :alt="$t('User avatar')"
                      :src="$store.state.user.avatar"
                    />
                  </div>
                  <div class="info">
                    <span class="title text-semibold">{{
                      $store.state.user.full_name
                    }}</span>
                    <span class="sub-title">{{ $store.state.user.email }}</span>
                  </div>
                </li>
              </ul>
            </li>
            <li class="divider" role="separator"></li>
            <li>
              <router-link to="/dashboard/account">
                <i class="fas fa-user-circle p-r-10" />
                <span>{{ $t("My account") }}</span>
              </router-link>
            </li>
            <li>
              <a @click.prevent="logout" href="#">
                <i class="fas fa-sign-out-alt p-r-10" />
                <span>{{ $t("Logout") }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <modal-select-conta />
    <modal-buscar-familia />
  </div>
</template>

<script>
import socket from "../../socket";
import notify from "./Notify.vue";

export default {
  name: "Navbar",
  components: {
    notify,
  },
  data() {
    return {
      sidebarOpen: true,
      size_left: "250",
    };
  },
  destroyed() {
    document.body.classList.add("sidebar-toggled");
  },
  mounted() {
    this.$store.dispatch("loadChats");
    // console.log('loadChats',this.$store.state.messages);
  },
  computed: {
    messages() {
      return this.$store.state.message_number;
    },
  },
  methods: {
    showPesquisa() {
      this.$bvModal.show("modal-busca-familia");
    },
    foldSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
      this.size_left = this.size_left == "70" ? "250" : "70";
      document.querySelectorAll(".app")[0].classList.toggle("side-nav-folded");

      var screen_size = document.body.clientWidth;

      if (screen_size > 992) {
        if (this.sidebarOpen) {
          document.getElementById("logosuas").innerHTML =
            '<img src="' + this.$store.state.settings.logotipo + '">';
        } else {
          document.getElementById("logosuas").innerHTML =
            '<img src="' +
            this.$store.state.settings.logotipo_mini +
            '" style="max-height:67px;">';
        }
      }
    },
    expandSidebar() {
      let App = $(".app");
      let SideNavBackDrop = $(".side-nav-backdrop");

      if (SideNavBackDrop.length) {
        SideNavBackDrop.remove();
      } else {
        let sideNavBackdrop = '<div class="side-nav-backdrop"></div>';
        App.append(sideNavBackdrop);
      }
      App.toggleClass("side-nav-expand");
      SideNavBackDrop.on("click", function (e) {
        App.removeClass("side-nav-expand");
        $(this).remove();
      });
    },
    logout() {
      this.$store.commit("logout");
      socket.disconnect();
      setTimeout(() => {
        this.$router.push("/auth/login");
      }, 100);
    },
  },
};
</script>

<style>
.app-navbar .header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
}
.app-navbar .header-container::before,
.app-navbar .header-container::after {
  display: none;
}
.app-navbar .nav-left,
.app-navbar .nav-right {
  flex-shrink: 0;
}
@media (max-width: 991px) {
  .header.app-navbar {
    width: 100% !important;
    margin-left: 0 !important;
    left: 0;
    right: 0;
  }
  .header.app-navbar .header-container .sidenav-fold-toggler {
    display: none;
  }
  .header.app-navbar .header-container .sidenav-expand-toggler {
    display: block;
  }
  .header.app-navbar .header-container .nav-right .dropdown-menu {
    right: 0 !important;
    left: auto;
    max-width: calc(100vw - 16px);
  }
}
@media (max-width: 575px) {
  .app-navbar .header-container .nav-left > li > a,
  .app-navbar .header-container .nav-right > li > a {
    padding-left: 6px;
    padding-right: 6px;
  }
}
.header {
  position: relative !important;
}
.line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  float: left;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  width: 400px !important;
  text-align: end;
  padding-right: 10px;
}
.block {
  height: 40%;
  width: 20%;
}
</style>
